
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.931","height":"17.931","viewBox":"0 0 17.931 17.931"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.965 16.437a7.471 7.471 0 10-7.471-7.472 7.474 7.474 0 007.471 7.472z","fill":"none","stroke":"#8d98aa","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M14.121 3.736l-10.46 10.46","fill":"none","stroke":"#8d98aa","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".34"}})])
          )
        }
      }
    